var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row text-left mt-2"},[_c('chart-evolution-main-number-opinion',{staticStyle:{"width":"100%","height":"280px"},attrs:{"chartData":_vm.getChartData(),"label":_vm.label}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }